import styled, { css } from 'styled-components/macro';
import { Image, ImageStyled } from '@yme/atoms/image';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { Link } from '@yme/components/Link';
import { colorCoreGray1000Base, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { AspectRatio as AspectRatioParams } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const ImageWrapperStyled = styled(Image) `
  ${ImageStyled} {
    max-height: 318px;
    aspect-ratio: ${AspectRatioParams.Square};
    object-fit: contain;
    object-position: center;
    background-color: ${colorCoreWhite1000};
  }
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
export const YAMTIconStyled = styled(SVGIcon) `
  width: 55px;

  ${ADAPTIVE.minWidth.desktop} {
    width: 84px;
  }

  svg {
    width: 100%;
  }
`;
export const DriverLicenseWrapperStyled = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: ${Z_INDEX.level1};
  right: 0;
  top: 0;
  margin: ${INDENT.xxs};
`;
export const DiscountTextStyled = styled.div `
  position: relative;

  &::before {
    display: ${({ isPriceWrapped }) => (isPriceWrapped ? 'none' : 'block')};
    position: absolute;
    top: calc(50% - 2px);
    width: 4px;
    height: 4px;
    border-radius: ${CORNER_RADIUS.circle};
    background-color: ${colorCoreGray1000Base};

    ${({ isRightToLeft }) => (isRightToLeft ? 'right: -14px;' : 'left: -14px;')}
  }

  ${({ isFromLabelShortForm }) => !isFromLabelShortForm &&
    css `
      &::before {
        content: '';
      }
    `}
`;
export const TextStyled = styled(RegularTextLevel4) `
  white-space: nowrap;

  ${ADAPTIVE.minWidth.tablet} {
    ${({ isBigDesktopFont }) => isBigDesktopFont && getTextStyles('Ubuntu', null, 16, 24)}
  }
`;
export const TitleStyled = styled(RegularTextLevel3) `
  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles('Ubuntu', null, 18, 28)}
  }
`;
